module.exports = __webpack_public_path__ + "img/lkw_a.477fae22.jpg";